import { Box, Stack, Typography } from '@mui/material';
import '../styles/Section5.scss';
import Img1 from '../../../../../../app/assets/images/landing/LiveTracking_Landing.jpg';
import Img2 from '../../../../../../app/assets/images/landing/SafetySurveillance_Landing.jpg';
import Img3 from '../../../../../../app/assets/images/landing/Speed Insights_Landing.jpg';
import Img4 from '../../../../../../app/assets/images/landing/Geo_fencing_Landing.jpg';
import Img5 from '../../../../../../app/assets/images/landing/ReportingandReminders_Landing.jpg';
import Img6 from '../../../../../../app/assets/images/landing/PointsofInterestsandNavigation_Landing.jpg';
import Img7 from '../../../../../../app/assets/images/landing/Tower_Landing.jpg';
import { Icon } from '@iconify/react';
import sectionConstants from '../../constants/SectionConstants';

const Section5 = () => {
  const images = [
    {
      id: '1',
      src: Img1,
      heading: 'Live Tracking',
      subContent: 'Real-time fleet monitoring, anywhere, anytime.',
      icon: 'subway:location'
    },
    {
      id: '2',
      src: Img2,
      heading: 'Route Optimization',
      subContent: 'Enhance efficiency with intelligent route planning and optimization',
      icon: 'solar:route-bold'
    },
    {
      id: '3',
      src: Img3,
      heading: 'Speed Insights',
      subContent: 'Detailed speed control and stopover analysis',
      icon: 'cil:speedometer'
    },
    {
      id: '4',
      src: Img4,
      heading: 'Geo-fencing',
      subContent: 'Set virtual boundaries and receive instant alerts for entry and exit.',
      icon: 'bx:world'
    },
    {
      id: '5',
      src: Img5,
      heading: 'Reporting and Reminders',
      subContent: 'Stay organized and proactive with reporting and automated reminders',
      icon: 'iconamoon:notification-fill'
    },
    {
      id: '6',
      src: Img6,
      heading: 'Points of Interests and Navigation',
      subContent:
        'Easily discover nearby locations and navigate seamlessly with integrated navigation features',
      icon: 'mingcute:navigation-fill'
    },
    {
      id: '7',
      src: Img7,
      heading: 'Safety Surveillance',
      subContent:
        'Instantly track reckless driving behaviors and promptly notify admin about potential safety risks',
      icon: 'heroicons-solid:status-offline'
    }
  ];
  return (
    <Box className='section5'>
      <Stack p={5} alignItems='center'>
        {sectionConstants.Highlights}
      </Stack>
      {images.map((item, index) => (
        <Box className={`overall_style section5-image${index + 1}`}>
          <Stack
            direction='row'
            alignItems='center'
            className='total-box-content'
            spacing={{ xs: -2, sm: -4.5, md: -5.5, lg: -6, xl: -6 }}
          >
            <Box className='orange-box' />
            <Stack>
              <Icon icon={item.icon} className='white-circle' />
            </Stack>

            <Stack spacing={2} className='typography'>
              <Typography className='head-content'>{item.heading}</Typography>
              <Typography className='body-content'>{item.subContent}</Typography>
            </Stack>
          </Stack>
        </Box>
      ))}
    </Box>
  );
};
export default Section5;
